import { Component, ElementRef, EventEmitter, forwardRef, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NzInputNumberComponent } from 'ng-zorro-antd/input-number';
import { DataPointDataType } from '../../dynamic-component';

@Component({
  selector: 'app-tags-select',
  templateUrl: './tags-select.component.html',
  styleUrls: ['./tags-select.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TagsSelectComponent)
    }
  ]
})
export class TagsSelectComponent implements OnInit, ControlValueAccessor {
  // 数据类型
  type = DataPointDataType;
  inputVisible = false;
  inputValue = '';
  @ViewChild('inputElement', { static: false }) inputElementRef: any;
  _dataType;
  @Input() set dataType(val) {
    this.value = [];
    console.log(val, 'dataType');
    this._dataType = val;
  }
  get dataType() {
    return this._dataType;
  }

  @Input()
  name: string;

  _value = [];

  @Input()
  set value(val: any) {
    this.writeValue(val);
  }
  get value(): any {
    return this._value;
  }

  @Output()
  valueChange = new EventEmitter<any>();
  constructor() {}

  ngOnInit() {}

  onChange(val) {
    this.valueChange.emit(this._value);
  }

  handleClose(removedTag: {}): void {
    this.value = this.value.filter(tag => tag !== removedTag);
  }

  sliceTagName(tag: string): string {
    const isLongTag = tag.length > 20;
    return isLongTag ? `${tag.slice(0, 20)}...` : tag;
  }

  showInput(): void {
    this.inputVisible = true;
    setTimeout(() => {
      // console.log(this);
      if (this.inputElementRef instanceof NzInputNumberComponent) {
        this.inputElementRef.inputElement.nativeElement.focus();
      } else if (this.inputElementRef instanceof ElementRef) {
        (this.inputElementRef.nativeElement as HTMLInputElement).focus();
      }
      // this.inputElement.inputElement.nativeElement.focus();
    }, 500);
  }

  handleInputConfirm(): void {
    // todo 重复校验 更新时传入的是字符串数组
    if (this.inputValue && this.value.indexOf(this.inputValue) === -1) {
      this.value = [...this.value, this.inputValue];
    }
    this.inputValue = '';
    this.inputVisible = false;

    // this.showInput(); // 回车后继续
  }

  writeValue(obj: any): void {
    this._value = obj;
    this.onChange(this._value);
  }
  registerOnChange(fn: any): void {
    this.valueChange.emit = fn;
  }
  registerOnTouched(fn: any): void {}
  setDisabledState?(isDisabled: boolean): void {
    // this.readonly = isDisabled;
  }
}
